import React, { useCallback, useEffect, useState } from 'react';

import Cell from '../Cell';
import { NormalCellTVProps } from '../types';
import { useIsInbound } from '../useIsInbound';

const NormalCellTV = ({
    config,
    item,
    rect,
    xVisibleStartOffset,
    xVisibleEndOffset,
    renderContent,
    onFocus,
    onPress,
}: NormalCellTVProps) => {
    const [focused, setFocused] = useState(false);

    const inbound = useIsInbound(rect, xVisibleStartOffset, xVisibleEndOffset);

    const _onFocus = useCallback(() => {
        setFocused(true);
    }, []);

    const onBlur = useCallback(() => {
        setFocused(false);
    }, []);

    const _onPress = useCallback(() => {
        onPress?.(item);
    }, [item, onPress]);

    // If we simply called it inside _onFocus, it was
    // not correct probably because of reusability
    useEffect(() => {
        if (focused) {
            onFocus?.(item);
        }
    }, [focused]);

    return (
        <Cell
            config={config}
            item={item}
            renderContent={renderContent}
            onFocus={_onFocus}
            onBlur={onBlur}
            onPress={_onPress}
            focusable={inbound}
            selected={focused}
        />
    );
};

export default NormalCellTV;
